import React, { useCallback, useMemo, useState } from 'react';
import { Description, SubTitle, DivRelative } from '../../components/layouts';
import Sequence from '../../components/sequence';
import { getSeqFrames, getTrack, pureTrans } from '../../helpers';
import Visibility from '../../components/Visibility';
import './style.scss';
import { AppContext } from '../../Context';
import { SeqencePlaceholder } from '../../components/sequence/Placeholder';

const track = getTrack({ block: 25 });

const FRAME_LENGTH = 85;

export function DesktopShifter() {
  const [framesLoaded, setFramesLoaded] = React.useState(false);
  const [frozen, freeze] = useState(true);
  const [progress, setProgress] = useState(0);
  const { index, a1, a2 } = useMemo(() => {
    return {
      index: pureTrans(progress, [0, 0.75], [0, FRAME_LENGTH - 1], 0),
      a1: pureTrans(progress, [0, 0.25], [1, 1], 3),
      a2: pureTrans(progress, [0, 0.75], [0, 0], 3)
    };
  }, [progress]);

  const handleUpdate = useCallback(
    (e, { calculations }) => {
      const { percentagePassed, pixelsPassed, height, offScreen } = calculations;
      freeze(offScreen || pixelsPassed <= -1000 || pixelsPassed >= height + 1000);
      setProgress(percentagePassed);
    },
    [setProgress, freeze]
  );

  const { webpSupport, webpDetectionFinished } = React.useContext(AppContext);

  const frames = useMemo(() => {
    return getSeqFrames({
      prefix: 'desktop',
      mobile: false,
      webpSupport: false,
      len: FRAME_LENGTH
    });
  }, [webpSupport]);

  const onFramesLoaded = useCallback(() => {
    setFramesLoaded(true);
  }, [setFramesLoaded]);

  const seqReady = !frozen && webpDetectionFinished;
  return (
    <Visibility
      fireOnMount
      offset={[-1000, 1000]}
      onUpdate={handleUpdate}
      className="page-section section-desktop_shifter inverted"
      data-track={track}
    >
      <div className="sticky-content">
        <DivRelative>
          <div className="section-content left">
            <div style={{ opacity: a1, transform: `translateY(${a2}%) translateZ(0)` }}>
              <SubTitle>变形器</SubTitle>
              <Description>
                无需往返于各个系统设置页面，新推出的变形器以一种所见即所得的方式，让你能在主屏幕随心所欲地对桌面效果DIY，轻松表达自我。
              </Description>
            </div>
          </div>
          <div className="section-background">
            <div className="sequence-wrapper">
              <Sequence current={index} frames={frames} active={seqReady} onload={onFramesLoaded} />
              <SeqencePlaceholder src={frames[frames.length - 1]} visible={!seqReady || !framesLoaded} />
            </div>
          </div>
        </DivRelative>
      </div>
    </Visibility>
  );
}
